module.exports = __webpack_public_path__ + "img/zhou7.30744344.png";